module.exports = __webpack_public_path__ + "f2588236088b85206b88ba4c75de6cb5.svg";